module.exports = __webpack_public_path__ + "static/media/ayuda-vendedor.55096d4c.jpg";